import React from 'react'
import routes from '../routes';
import { WithSubRoute } from '../components/WithSubRoute';

const Main = () => (
    <main>
        {routes.map((route, idx) => {
            return route.component ? (
                <WithSubRoute key={idx} {...route} />
            ) : console.log(null);
        },)}

    </main>
  )
  
  export default Main


// WEBPACK FOOTER //
// ./src/containers/Main.jsx